import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';

export default class PathwayMapView extends BaseView {

    init() {
        super.init();
        const self = this;
        let url = '/api/guides';
        let param = {
            by_pathway: $('#pathwaytitle').data('id'),
        };
        if ($('#pathwaymaps').length > 0) {
            Api.send(url, param, 'get').done(function (r) {
                self.render(r);
            });
        }
    }

    render(pathwaymaps) {
        const self = this;
        const items = $('#pathwaymaps .pathway-items');
        items.empty();
        for (let i = 0; i < pathwaymaps.length; i++) {
            items.append(self.BuildListHtml(pathwaymaps[i].id, pathwaymaps[i].title));
        }
        let url = '/api/guides';
        let param = {
            notpathway: $('#pathwaytitle').data('id'),
            pathwaymap: true
        };
        Api.send(url, param, 'get').done(function (r) {
            self.renderAvailable(r);
        });
    }

    renderAvailable(pathwaymaps) {
        const self = this;
        const available = $('#pathwaymaps .available-items');
        available.empty();
        for (let i = 0; i < pathwaymaps.length; i++) {
            available.append(self.BuildListHtml(pathwaymaps[i].id, pathwaymaps[i].title));
        }
        self.setEvents();
    }

    setEvents() {
        const self = this;
        super.setEvents();
        //let url = '/api/pathwaymap';
        let data = {pathway_id: $('#pathwaytitle').data('id')};
        data.guides = {};

        $(".available-items, .pathway-items").sortable({
            connectWith: ".ui-sortable",
            update: function () {
                if (!$('#pathwaymaps .pathway-items').hasClass('receiving')) {
                    self.PathwaymapApiUpdateIndex();
                }
            }
        });


        //Delete
        $("#pathwaymaps .pathway-items").on("click", ".delete", function () {
            const $li = $(this).parents('li:eq(0)');
            //Confirm
            Confirm({
                title: Lang.removelink,
                msg: Lang.removeguide,
                onConfirm: function () {
                    const items = $('#pathwaymaps .available-items');
                    items.append(self.BuildListHtml($li.data('id'), $li.find('.title').text()));
                    $li.remove();
                    self.PathwaymapApiUpdateIndex();
                }
            });
            return false;
        });

        // selecting all items in the list
        $("#pathwaymaps").on('change.sel', '.select-all', function () {
            $(this).parents('.grid-item').find('ul input').prop('checked', $(this).prop('checked'));
        });

        $("#pathwaymaps").on('click.adds', '.add-selected', function () {
            const items = $('#pathwaymaps .pathway-items');
            $('.available-items input:checked').each(function () {
                let id = $(this).parents('li').data('id');
                let title = $(this).parents('li').find('.title').text();
                items.append(self.BuildListHtml(id, title));
                $(this).parents('li').remove();
            });

            self.PathwaymapApiUpdateIndex();
        });

        $("#pathwaymaps").on('click.dels', '.delete-selected', function () {
            //Confirm
            Confirm({
                title: Lang.removelink,
                msg: Lang.removeguides,
                onConfirm: function () {
                    const items = $('#pathwaymaps .available-items');
                    $('.pathway-items input:checked').each(function () {
                        let id = $(this).parents('li').data('id');
                        let title = $(this).parents('li').find('.title').text();
                        items.append(self.BuildListHtml(id, title));
                        $(this).parents('li').remove();
                    });
                    self.PathwaymapApiUpdateIndex();
                }
            });
            return false;
        });


        $("#pathway-guide-filter").on("keyup.srch", function (evt) {
            let filter_string = evt.target.value.toLowerCase();
            let guides = [...$('.available-items > li')];
            guides.filter(item => {
                $(item).hide();
                return item.innerText.toLowerCase().includes(filter_string);
            }).forEach(match => $(match).show());
        });
    }

    BuildListHtml(id, title) {
        // pathway-item addition
        return `<li data-id="` + id + `">
            <span class="control"><input type="checkbox"></span>
            <span class="title">` + title + `</span>
            <a class="delete btn btn-warning"><i class="jsicon-trashcan"></i></a>
            </li>`;
    }

    /**
     *  Update indexes
     */
    PathwaymapApiUpdateIndex() {
        // console.log('updateIndex');
        const url = `/api/pathwaymap/${$('#pathwaytitle').data('id')}/indexes`;
        const data = {};
        data.guides = {};
        const $li = $('#pathwaymaps .pathway-items li');

        $li.each(function () {
            if ($(this).data('id')) {
                data.guides[$(this).data('id')] = $li.index($(this));
            }
        });
        //API Call
        Api.send(url, data, 'patch');
    }
}
